import { render, staticRenderFns } from "./home1.vue?vue&type=template&id=563a9077&scoped=true"
import script from "./home1.vue?vue&type=script&lang=js"
export * from "./home1.vue?vue&type=script&lang=js"
import style0 from "./home1.vue?vue&type=style&index=0&id=563a9077&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563a9077",
  null
  
)

export default component.exports